<div class="code-input-wrapper" (paste)="onPaste($event)">
  <input
    *ngFor="let _ of digits; index as i"
    #codeInput
    [disabled]="disabled"
    [value]="digits[i]"
    maxlength="1"
    inputmode="numeric"
    pattern="[0-9]*"
    autocomplete="one-time-code"
    class="code-input"
    type="text"
    (input)="onInput($event, i)"
    (change)="onChange($event, i)"
    (keyup)="onKeyUp()"
    (keydown)="onKeyDown($event, i)"
    aria-label="SMS-Code Ziffer {{ i + 1 }}"
  />
</div>
